







































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Factura, FacturaItem } from "@/typings/store/plugins/easyFirestore/facturas";
import { DataFormularioFactura } from "@/typings/components/facturas/formulario";
import { totalesDeItems } from "@/helpers/facturacion";
import { aISOLocal } from "@/helpers/fechas";

@Component
export default class FormularioFactura extends Vue {
  @Prop() readonly factura!: Factura | null;
  @Prop() readonly cargando!: boolean;

  items: FacturaItem[] = [];
  fechaVencimiento = "";
  error = "";

  created(): void {
    if (!this.factura) return;
    // Copia de trabajo: no se toca la factura hasta guardar.
    this.items = (this.factura.items || []).map((item) => ({ ...item }));
    const vence = this.factura.fechaVencimiento ? new Date(this.factura.fechaVencimiento) : null;
    this.fechaVencimiento = vence && !isNaN(vence.getTime()) ? aISOLocal(vence) : "";
  }

  get totales(): { montoNeto: number; montoIva: number; montoTotal: number; montoExento?: number } {
    return totalesDeItems(this.items);
  }

  cambiarExento(item: FacturaItem, exento: boolean): void {
    this.$set(item, "exento", exento);
    this.$set(item, "manual", true);
  }

  moneda(valor: number): string {
    return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(valor || 0);
  }

  /** Un ítem tocado a mano queda marcado; si ya tiene monto deja de estar pendiente. */
  marcarManual(item: FacturaItem): void {
    this.$set(item, "manual", true);
    if (item.pendiente && Number(item.montoNeto) > 0) this.$set(item, "pendiente", false);
  }

  agregarItem(): void {
    this.items.push({ glosa: `Varios - ${this.factura?.periodoFacturado ?? ""}`, montoNeto: 0, manual: true });
  }

  quitarItem(index: number): void {
    this.items.splice(index, 1);
  }

  @Emit("close")
  onClose(): null {
    return null;
  }

  @Emit("click-guardar")
  onClickGuardar(data: DataFormularioFactura): DataFormularioFactura {
    return data;
  }

  guardar(): void {
    this.error = "";
    if (!this.factura) return;
    if (!this.items.length) {
      this.error = "La factura debe tener al menos un ítem. Si no corresponde cobrar, elimina el borrador.";
      return;
    }
    if (this.items.some((i) => !String(i.glosa || "").trim())) {
      this.error = "Todos los ítems necesitan una glosa.";
      return;
    }
    if (this.items.some((i) => !Number.isFinite(Number(i.montoNeto)) || Number(i.montoNeto) < 0)) {
      this.error = "Los montos deben ser números mayores o iguales a 0.";
      return;
    }
    if (!this.fechaVencimiento) {
      this.error = "Indica la fecha de vencimiento.";
      return;
    }
    const [y, m, d] = this.fechaVencimiento.split("-").map(Number);
    const items = this.items.map((i) => ({ ...i, montoNeto: Math.round(Number(i.montoNeto)) }));
    const totales = totalesDeItems(items);
    this.onClickGuardar({
      doc: {
        ...this.factura,
        items,
        fechaVencimiento: new Date(y, m - 1, d).toISOString(),
        ...totales,
        // Si se quitó el último ítem exento, el monto exento vuelve a 0.
        montoExento: totales.montoExento || 0,
      },
    });
  }
}
